import {styled} from "styled-components";
import {Card} from "antd";
import {BellOutlined} from "@ant-design/icons";

export const StyledBellOutlined = styled(BellOutlined)`
font-size: 1.65rem;
  
`;